import React from "react";
import {Loader} from "../../components/Loader";
import {ListComponent} from "../../components/ListComponent";
import {FormGroup} from "../../components/FormComponent/FormGroup";
import {TableFooter} from "../../components/ListComponent/TableFooter";
import {Util} from "../../components/Util";
import {FormattedNumber} from "../../components/Elements/FormattedNumber";
import {DateTime} from "../../components/ListComponent/DateTime";
import {Dictionary} from "../../components/Dictionary";

export class EmptyStorages extends ListComponent {
    private item: any = null;

    protected getRequestUrl(): RequestInfo | URL {
        return '/storage/empty-storages';
    }

    render() {
        if (!this.state) {
            return <Loader/>;
        }

        const params: {} | any = this.getFormData(), dictionary: Dictionary = this.dictionary;
        this.state?.item && (this.item = this.state?.item);

        return (
            <>
                <div className="row">
                    <form className="x-form" method="POST" onSubmit={this.handleSubmit}>
                        <div className="row">
                            <h5>{this.dictionary.get['search']}</h5>

                            <div className="col-lg-3 col-md-4">
                                <div className="alert alert-info" role="alert" style={{top: '12px'}}>
                                    {this.dictionary.get['latest-snapshot']}: &nbsp;
                                    <DateTime value={this.item?.latestSnapshotDate} inline={true}/>
                                </div>
                            </div>

                            <div className="col-lg-3 col-md-4">
                                <FormGroup.Input {...{id: 'id', defaultValue: params?.id}}/>
                            </div>

                            <div className="col-lg-3 col-md-4">
                                <FormGroup.Input {...{id: 'name', defaultValue: params?.name}}/>
                            </div>


                            <div className="col-lg-3 col-md-4">
                                <FormGroup.Input {...{id: 'type', defaultValue: params?.type}}/>
                            </div>
                            <div className="col-lg-3 col-md-4">
                                <FormGroup.Input {...{id: 'zone_name', defaultValue: params?.zone_name}}/>
                            </div>
                            <div className="col-lg-3 col-md-4">
                                <FormGroup.Input {...{id: 'zone_type', defaultValue: params?.zone_type}}/>
                            </div>
                        </div>

                        <input type="hidden" name="sort" defaultValue={params.sort ?? 'id:d'}/>
                        {this.listOfSearchParams(params)}

                        <div className="row">
                            <div className="col-12 caption">
                                <button className="btn btn-sm btn-primary" type="submit">
                                    {this.dictionary.get['search']}
                                </button>
                                &nbsp;
                                <button className="btn btn-sm btn-light"
                                        onClick={((event: MouseEvent | any) => {
                                            event.preventDefault();
                                            this.exportTableData('/storage/empty-storages-export')
                                        })}>
                                    {this.dictionary.get['export']}
                                </button>
                                &nbsp;
                                &nbsp;
                                <h6>
                                    {this.dictionary.get['empty-storages']}: &nbsp;
                                    <strong>{this.state.count ? this.state.count : '-'}</strong> {this.dictionary.get['pc']}
                                </h6>
                            </div>
                        </div>
                    </form>
                </div>

                <div className="row">
                    <div className="table-responsive">
                        <table className="table table-hover table-sm align-middle">
                            <thead>
                            <tr>
                                <th className="sortable" data-sortkey="s.id">
                                    ID <i className="bi bi-sort-down"></i>
                                </th>
                                <th className="sortable"
                                    data-sortkey="s.`service_id`">{this.dictionary.get['service_id']}</th>
                                <th className="sortable" data-sortkey="s.`name`">{this.dictionary.get['name']}</th>
                                <th className="sortable" data-sortkey="s.`type`">{this.dictionary.get['type']}</th>
                                <th className="sortable"
                                    data-sortkey="s.`zone_type`">{this.dictionary.get['zone_type']}</th>
                                <th className="sortable"
                                    data-sortkey="s.`zone_name`">{this.dictionary.get['zone_name']}</th>
                                <th className="sortable"
                                    data-sortkey="s.`dimensions`">{this.dictionary.get['dimensions']}</th>
                                <th className="sortable"
                                    data-sortkey="s.`capacity`">{this.dictionary.get['capacity']}</th>
                            </tr>
                            </thead>
                            <tbody>
                            {this.state.items.map(function (elem: any) {
                                return (
                                    <tr key={elem.id} data-id={elem.id}>
                                        <td style={{textAlign: 'right'}} onClick={Util.copy}
                                            className="copy">{elem.id}</td>
                                        <td style={{textAlign: 'right'}}>{elem.service_id}</td>
                                        <td onClick={Util.copy} className="copy">{elem.name}</td>
                                        <td onClick={Util.copy} className="copy">{elem.type}</td>
                                        <td onClick={Util.copy} className="copy">{elem.zone_type}</td>
                                        <td onClick={Util.copy} className="copy">{elem.zone_name}</td>
                                        <td onClick={Util.copy} className="copy">{elem.dimensions}</td>
                                        <FormattedNumber value={elem.capacity}
                                                         parentNode="td" className="copy" suffix={dictionary.get['pc']}
                                                         onClick={Util.copy} style={{textAlign: 'right'}}/>
                                    </tr>
                                )
                            })}
                            </tbody>
                            {this.state.itemsCount < this.limit ? (
                                <TableFooter colspan={8}/>
                            ) : ''}
                        </table>
                        {this.state.isLoading && <Loader/>}
                    </div>
                </div>
            </>
        )
            ;
    }
}
